import {
  SHOW_SUCCESS_NOTIFICATION,
  HIDE_SUCCESS_NOTIFICATION,
  IS_GET_QUESTIONS_INPROGRESS,
  IS_SUBMIT_INPROGRESS,
  IS_SURVEY_ENABLED,
  IS_SURVEY_SUBMITTED,
  SHOW_FAILURE_NOTIFICATION,
} from '../actions/ui/type';

const feedbackQuestionsReducer = (state, { type, payload }) => {
  const currentFeedbackState = state;
  switch (type) {
    case SHOW_SUCCESS_NOTIFICATION:
      return {
        ...currentFeedbackState,
        isSuccessNotificationShown: true,
      };

    case HIDE_SUCCESS_NOTIFICATION:
      return {
        ...currentFeedbackState,
        isSuccessNotificationShown: false,
      };

    case SHOW_FAILURE_NOTIFICATION:
      return {
        ...currentFeedbackState,
        isFailureNotificationShown: true,
      };
    case IS_GET_QUESTIONS_INPROGRESS:
      return {
        ...currentFeedbackState,
        isGetQuestionsInProgress: payload,
      };
    case IS_SUBMIT_INPROGRESS:
      return {
        ...currentFeedbackState,
        isSubmitInProgress: payload,
      };
    case IS_SURVEY_ENABLED:
      return {
        ...currentFeedbackState,
        isSurveyEnabled: payload,
      };
    case IS_SURVEY_SUBMITTED:
      return {
        ...currentFeedbackState,
        isSurveySubmitted: payload,
      };

    default:
      return currentFeedbackState;
  }
};

export default feedbackQuestionsReducer;
